import { GoogleLogo, InstagramLogo, MetaLogo, TiktokLogo, YoutubeLogo } from '@phosphor-icons/react';
import { PLATFORM_COVERAGE_COPY } from './landingContent';
import { useLandingReveal, usePrefersReducedMotion } from './useLandingReveal';

const PLATFORM_ICONS = {
  tiktok: TiktokLogo,
  instagram: InstagramLogo,
  youtube: YoutubeLogo,
  'meta-ads': MetaLogo,
  'google-ads': GoogleLogo,
  'tiktok-ads': TiktokLogo,
};

function PlatformGroup({ group }) {
  return (
    <div className="lp-platforms__group">
      <h3 className="lp-platforms__group-label">{group.label}</h3>
      <ul className="lp-platforms__list">
        {group.platforms.map((platform) => {
          const Icon = PLATFORM_ICONS[platform.id];
          return (
            <li className="lp-platforms__item" key={platform.id}>
              <span aria-hidden="true">{Icon ? <Icon size={18} /> : null}</span>
              <span>{platform.name}</span>
              {platform.planned && (
                <span className="lp-platforms__planned">Planned</span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

function PlatformCoverage() {
  const reducedMotion = usePrefersReducedMotion();
  const [revealRef, revealed] = useLandingReveal();
  const visible = revealed || reducedMotion;

  return (
    <section className="lp-section lp-platforms" aria-labelledby="lp-platforms-heading">
      <div className="lp-container">
        <div ref={revealRef} className={`lp-reveal${visible ? ' lp-reveal--visible' : ''}`}>
          <h2 id="lp-platforms-heading" className="lp-heading">
            {PLATFORM_COVERAGE_COPY.heading}
          </h2>
          <p className="lp-body">{PLATFORM_COVERAGE_COPY.body}</p>
          <div className="lp-platforms__groups">
            {PLATFORM_COVERAGE_COPY.groups.map((group) => (
              <PlatformGroup key={group.id} group={group} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PlatformCoverage;
